var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"freesample-box text-center flex-wrap"},[_c('img',{attrs:{"src":require("assets/images/icons/about-04.svg"),"alt":""}}),_vm._v(" "),_c('NuxtLink',{staticClass:"btn btn-primary w-full",attrs:{"to":`/diagrams/${_vm.$config.freeSampleUrl}/`}},[_vm._v("\n    Download free sample\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }